module.exports = __webpack_public_path__ + "img/gun-turret-gun-extension-shadow.8c7be7c1.png";